module.exports = __webpack_public_path__ + "assets/img/jane_williams_photo.85452746.svg";